module.exports = __webpack_public_path__ + "media/images/emblems/Matzendorf-blason-6b224e9cf04b220f8ae9ac2193462fe0.png";